<template>
  <div class="dem-edi-ser-doc-campos">
    <template v-if="cpntSDocTp === 'NFSe'">
      <template v-if="cpntMostrarDetalhes === true">
        <div>
          <App-Select :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_nat_ope"
            :cpntStatus='campos.s_doc_nat_ope.status'
            :cpntId='campos.s_doc_nat_ope.id'
            :cpntTabIndex='campos.s_doc_nat_ope.tabIndex'
            :cpntNome='campos.s_doc_nat_ope.nome'
            :cpntValue='campos.s_doc_nat_ope.value'
            :cpntMensagem='campos.s_doc_nat_ope.mensagem'
            :cpntMensagemTipo='campos.s_doc_nat_ope.mensagemTipo'
            :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_nat_ope.disabled'
            :cpntMostrar='campos.s_doc_nat_ope.mostrar'
            :cpntExplica='campos.s_doc_nat_ope.explica'
            :cpntPlaceholder='campos.s_doc_nat_ope.placeholder'
            :cpntValueRef='campos.s_doc_nat_ope.valueRef'
            :cpntRouter='campos.s_doc_nat_ope.router'
            :cpntField='campos.s_doc_nat_ope.field'
            :cpntWhere='campos.s_doc_nat_ope.where'
            :cpntAddButForm='campos.s_doc_nat_ope.addButForm'
            :cpntKeyMostra='campos.s_doc_nat_ope.keyMostra'
            :cpntTipoOrder='campos.s_doc_nat_ope.tipoOrder'
            :cpntOrder='campos.s_doc_nat_ope.order'
            :cpntOptions='campos.s_doc_nat_ope.options'
            :cpntKeyValue='campos.s_doc_nat_ope.keyValue'
            :cpntSearchMinimo='campos.s_doc_nat_ope.searchMinimo'
            :cpntMask='campos.s_doc_nat_ope.mask'
            :cpntOptionInicialNome='campos.s_doc_nat_ope.optionInicialNome'
            :cpntOptionInicialValue='campos.s_doc_nat_ope.optionInicialValue'

            :cpntOnChange='campos.s_doc_nat_ope.onChange'
            :cpntOnBlur='campos.s_doc_nat_ope.onBlur'
            :cpntOnBuscarOptions='campos.s_doc_nat_ope.onBuscarOptions'
            :cpntOnKeyPressEnter='campos.s_doc_nat_ope.onKeyPressEnter'
            ref="s_doc_nat_ope"
          ></App-Select>
        </div>

        <div>
          <App-Select :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_ramo_id"
            :cpntStatus='campos.s_doc_ramo_id.status'
            :cpntId='campos.s_doc_ramo_id.id'
            :cpntTabIndex='campos.s_doc_ramo_id.tabIndex'
            :cpntNome='campos.s_doc_ramo_id.nome'
            :cpntValue='campos.s_doc_ramo_id.value'
            :cpntMensagem='campos.s_doc_ramo_id.mensagem'
            :cpntMensagemTipo='campos.s_doc_ramo_id.mensagemTipo'
            :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_ramo_id.disabled'
            :cpntMostrar='campos.s_doc_ramo_id.mostrar'
            :cpntExplica='campos.s_doc_ramo_id.explica'
            :cpntPlaceholder='campos.s_doc_ramo_id.placeholder'
            :cpntValueRef='campos.s_doc_ramo_id.valueRef'
            :cpntRouter='campos.s_doc_ramo_id.router'
            :cpntField='campos.s_doc_ramo_id.field'
            :cpntWhere='campos.s_doc_ramo_id.where'
            :cpntAddButForm='campos.s_doc_ramo_id.addButForm'
            :cpntKeyMostra='campos.s_doc_ramo_id.keyMostra'
            :cpntTipoOrder='campos.s_doc_ramo_id.tipoOrder'
            :cpntOrder='campos.s_doc_ramo_id.order'
            :cpntOptions='campos.s_doc_ramo_id.options'
            :cpntKeyValue='campos.s_doc_ramo_id.keyValue'
            :cpntSearchMinimo='campos.s_doc_ramo_id.searchMinimo'
            :cpntMask='campos.s_doc_ramo_id.mask'
            :cpntOptionInicialNome='campos.s_doc_ramo_id.optionInicialNome'
            :cpntOptionInicialValue='campos.s_doc_ramo_id.optionInicialValue'

            :cpntOnChange='campos.s_doc_ramo_id.onChange'
            :cpntOnBlur='campos.s_doc_ramo_id.onBlur'
            :cpntOnBuscarOptions='campos.s_doc_ramo_id.onBuscarOptions'
            :cpntOnKeyPressEnter='campos.s_doc_ramo_id.onKeyPressEnter'
            ref="s_doc_ramo_id"
          ></App-Select>
        </div>
        
        <div>
          <App-Select :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_ati_id"
            :cpntStatus='campos.s_doc_ati_id.status'
            :cpntId='campos.s_doc_ati_id.id'
            :cpntTabIndex='campos.s_doc_ati_id.tabIndex'
            :cpntNome='campos.s_doc_ati_id.nome'
            :cpntValue='campos.s_doc_ati_id.value'
            :cpntMensagem='campos.s_doc_ati_id.mensagem'
            :cpntMensagemTipo='campos.s_doc_ati_id.mensagemTipo'
            :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_ati_id.disabled'
            :cpntMostrar='campos.s_doc_ati_id.mostrar'
            :cpntExplica='campos.s_doc_ati_id.explica'
            :cpntPlaceholder='campos.s_doc_ati_id.placeholder'
            :cpntValueRef='campos.s_doc_ati_id.valueRef'
            :cpntRouter='campos.s_doc_ati_id.router'
            :cpntField='campos.s_doc_ati_id.field'
            :cpntWhere='campos.s_doc_ati_id.where'
            :cpntAddButForm='campos.s_doc_ati_id.addButForm'
            :cpntKeyMostra='campos.s_doc_ati_id.keyMostra'
            :cpntTipoOrder='campos.s_doc_ati_id.tipoOrder'
            :cpntOrder='campos.s_doc_ati_id.order'
            :cpntOptions='campos.s_doc_ati_id.options'
            :cpntKeyValue='campos.s_doc_ati_id.keyValue'
            :cpntSearchMinimo='campos.s_doc_ati_id.searchMinimo'
            :cpntMask='campos.s_doc_ati_id.mask'
            :cpntOptionInicialNome='campos.s_doc_ati_id.optionInicialNome'
            :cpntOptionInicialValue='campos.s_doc_ati_id.optionInicialValue'

            :cpntOnChange='campos.s_doc_ati_id.onChange'
            :cpntOnBlur='campos.s_doc_ati_id.onBlur'
            :cpntOnBuscarOptions='campos.s_doc_ati_id.onBuscarOptions'
            :cpntOnKeyPressEnter='campos.s_doc_ati_id.onKeyPressEnter'
            ref="s_doc_ati_id"
          ></App-Select>
        </div>

        <div>
          <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_cod_tri"
            :cpntStatus='campos.s_doc_cod_tri.status'
            :cpntId='campos.s_doc_cod_tri.id'
            :cpntTabIndex='campos.s_doc_cod_tri.tabIndex'
            :cpntClassDivField='campos.s_doc_cod_tri.classDivField'
            :cpntNome='campos.s_doc_cod_tri.nome'
            :cpntValue='campos.s_doc_cod_tri.value'
            :cpntAutoComplete='campos.s_doc_cod_tri.autocomplete'
            :cpntMask='campos.s_doc_cod_tri.mask'
            :cpntOptionInicialNome='campos.s_doc_cod_tri.optionInicialNome'
            :cpntOptionInicialValue='campos.s_doc_cod_tri.optionInicialValue'
            :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_cod_tri.disabled === true'
            :cpntMostrar='campos.s_doc_cod_tri.mostrar'
            :cpntAutoFocus='campos.s_doc_cod_tri.autofocus'
            :cpntMensagem='campos.s_doc_cod_tri.mensagem'
            :cpntMensagemTipo='campos.s_doc_cod_tri.mensagemTipo'
            :cpntPlaceholder='campos.s_doc_cod_tri.placeholder'
            :cpntPosicionar='campos.s_doc_cod_tri.posicionar'
            :cpntOnChange='campos.s_doc_cod_tri.onChange'
            :cpntOnBlur='campos.s_doc_cod_tri.onBlur'
            ref='s_doc_cod_tri'
          ></App-Input>

          <App-Autocompletar :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_mun_pre_ser"
            :cpntStatus='campos.s_doc_mun_pre_ser.status'
            :cpntId='campos.s_doc_mun_pre_ser.id'
            :cpntTabIndex='campos.s_doc_mun_pre_ser.tabIndex'
            :cpntNome='campos.s_doc_mun_pre_ser.nome'
            :cpntValue='campos.s_doc_mun_pre_ser.value'
            :cpntMensagem='campos.s_doc_mun_pre_ser.mensagem'
            :cpntMensagemTipo='campos.s_doc_mun_pre_ser.mensagemTipo'
            :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_mun_pre_ser.disabled'
            :cpntMostrar='campos.s_doc_mun_pre_ser.mostrar'
            :cpntExplica='campos.s_doc_mun_pre_ser.explica'
            :cpntPlaceholder='campos.s_doc_mun_pre_ser.placeholder'
            :cpntValueRef='campos.s_doc_mun_pre_ser.valueRef'
            :cpntRouter='campos.s_doc_mun_pre_ser.router'
            :cpntMethod='campos.s_doc_mun_pre_ser.method'
            :cpntField='campos.s_doc_mun_pre_ser.field'
            :cpntWhere='campos.s_doc_mun_pre_ser.where'
            :cpntAddButForm='campos.s_doc_mun_pre_ser.addButForm'
            :cpntKeyMostra='campos.s_doc_mun_pre_ser.keyMostra'
            :cpntTipoOrder='campos.s_doc_mun_pre_ser.tipoOrder'
            :cpntOrder='campos.s_doc_mun_pre_ser.order'
            :cpntOptions='campos.s_doc_mun_pre_ser.options'
            :cpntKeyValue='campos.s_doc_mun_pre_ser.keyValue'
            :cpntSearchMinimo='campos.s_doc_mun_pre_ser.searchMinimo'
            :cpntMask='campos.s_doc_mun_pre_ser.mask'
            :cpntOptionInicialNome='campos.s_doc_mun_pre_ser.optionInicialNome'
            :cpntOptionInicialValue='campos.s_doc_mun_pre_ser.optionInicialValue'
            :cpntNewOption='campos.s_doc_mun_pre_ser.newOption'

            :cpntOnChange='campos.s_doc_mun_pre_ser.onChange'
            :cpntOnBlur='campos.s_doc_mun_pre_ser.onBlur'
            :cpntOnBuscarOptions='campos.s_doc_mun_pre_ser.onBuscarOptions'
            :cpntOnKeyPressEnter='campos.s_doc_mun_pre_ser.onKeyPressEnter'
            ref="s_doc_mun_pre_ser"
          ></App-Autocompletar>
        </div>

        <div>
          <App-Textarea :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_descricao"
            :cpntStatus='campos.s_doc_descricao.status'
            :cpntId='campos.s_doc_descricao.id'
            :cpntTabIndex='campos.s_doc_descricao.tabIndex'
            :cpntClassDivField='campos.s_doc_descricao.classDivField'
            :cpntNome='campos.s_doc_descricao.nome'
            :cpntValue='campos.s_doc_descricao.value'
            :cpntAutoComplete='campos.s_doc_descricao.autocomplete'
            :cpntMask='campos.s_doc_descricao.mask'
            :cpntOptionInicialNome='campos.s_doc_descricao.optionInicialNome'
            :cpntOptionInicialValue='campos.s_doc_descricao.optionInicialValue'
            :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_descricao.disabled === true'
            :cpntMostrar='campos.s_doc_descricao.mostrar'
            :cpntAutoFocus='campos.s_doc_descricao.autofocus'
            :cpntMensagem='campos.s_doc_descricao.mensagem'
            :cpntMensagemTipo='campos.s_doc_descricao.mensagemTipo'
            :cpntPlaceholder='campos.s_doc_descricao.placeholder'
            :cpntPosicionar='campos.s_doc_descricao.posicionar'
            :cpntOnChange='campos.s_doc_descricao.onChange'
            :cpntOnBlur='campos.s_doc_descricao.onBlur'
            ref='s_doc_descricao'
          ></App-Textarea>
        </div>

        <template v-if="$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 40 ], null, false) === true">
          <div class="totais">
            <div>
              Valores da NFS-e
            </div>
          </div>

          <div>
            <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_vTServico"
              :cpntStatus='campos.s_doc_vTServico.status'
              :cpntId='campos.s_doc_vTServico.id'
              :cpntTabIndex='campos.s_doc_vTServico.tabIndex'
              :cpntClassDivField='campos.s_doc_vTServico.classDivField'
              :cpntNome='campos.s_doc_vTServico.nome'
              :cpntValue='campos.s_doc_vTServico.value'
              :cpntAutoComplete='campos.s_doc_vTServico.autocomplete'
              :cpntMask='campos.s_doc_vTServico.mask'
              :cpntOptionInicialNome='campos.s_doc_vTServico.optionInicialNome'
              :cpntOptionInicialValue='campos.s_doc_vTServico.optionInicialValue'
              :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_vTServico.disabled === true'
              :cpntMostrar='campos.s_doc_vTServico.mostrar'
              :cpntAutoFocus='campos.s_doc_vTServico.autofocus'
              :cpntMensagem='campos.s_doc_vTServico.mensagem'
              :cpntMensagemTipo='campos.s_doc_vTServico.mensagemTipo'
              :cpntPlaceholder='campos.s_doc_vTServico.placeholder'
              :cpntPosicionar='campos.s_doc_vTServico.posicionar'
              :cpntOnChange='campos.s_doc_vTServico.onChange'
              :cpntOnBlur='campos.s_doc_vTServico.onBlur'
              ref='s_doc_vTServico'
            ></App-Input>

            <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_deducao_bc"
              :cpntStatus='campos.s_doc_deducao_bc.status'
              :cpntId='campos.s_doc_deducao_bc.id'
              :cpntTabIndex='campos.s_doc_deducao_bc.tabIndex'
              :cpntClassDivField='campos.s_doc_deducao_bc.classDivField'
              :cpntNome='campos.s_doc_deducao_bc.nome'
              :cpntValue='campos.s_doc_deducao_bc.value'
              :cpntAutoComplete='campos.s_doc_deducao_bc.autocomplete'
              :cpntMask='campos.s_doc_deducao_bc.mask'
              :cpntOptionInicialNome='campos.s_doc_deducao_bc.optionInicialNome'
              :cpntOptionInicialValue='campos.s_doc_deducao_bc.optionInicialValue'
              :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_deducao_bc.disabled === true'
              :cpntMostrar='campos.s_doc_deducao_bc.mostrar'
              :cpntAutoFocus='campos.s_doc_deducao_bc.autofocus'
              :cpntMensagem='campos.s_doc_deducao_bc.mensagem'
              :cpntMensagemTipo='campos.s_doc_deducao_bc.mensagemTipo'
              :cpntPlaceholder='campos.s_doc_deducao_bc.placeholder'
              :cpntPosicionar='campos.s_doc_deducao_bc.posicionar'
              :cpntOnChange='campos.s_doc_deducao_bc.onChange'
              :cpntOnBlur='campos.s_doc_deducao_bc.onBlur'
              ref='s_doc_deducao_bc'
            ></App-Input>

            <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_desconto"
              :cpntStatus='campos.s_doc_desconto.status'
              :cpntId='campos.s_doc_desconto.id'
              :cpntTabIndex='campos.s_doc_desconto.tabIndex'
              :cpntClassDivField='campos.s_doc_desconto.classDivField'
              :cpntNome='campos.s_doc_desconto.nome'
              :cpntValue='campos.s_doc_desconto.value'
              :cpntAutoComplete='campos.s_doc_desconto.autocomplete'
              :cpntMask='campos.s_doc_desconto.mask'
              :cpntOptionInicialNome='campos.s_doc_desconto.optionInicialNome'
              :cpntOptionInicialValue='campos.s_doc_desconto.optionInicialValue'
              :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_desconto.disabled === true'
              :cpntMostrar='campos.s_doc_desconto.mostrar'
              :cpntAutoFocus='campos.s_doc_desconto.autofocus'
              :cpntMensagem='campos.s_doc_desconto.mensagem'
              :cpntMensagemTipo='campos.s_doc_desconto.mensagemTipo'
              :cpntPlaceholder='campos.s_doc_desconto.placeholder'
              :cpntPosicionar='campos.s_doc_desconto.posicionar'
              :cpntOnChange='campos.s_doc_desconto.onChange'
              :cpntOnBlur='campos.s_doc_desconto.onBlur'
              ref='s_doc_desconto'
            ></App-Input>

            <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_bc"
              :cpntStatus='campos.s_doc_bc.status'
              :cpntId='campos.s_doc_bc.id'
              :cpntTabIndex='campos.s_doc_bc.tabIndex'
              :cpntClassDivField='campos.s_doc_bc.classDivField'
              :cpntNome='campos.s_doc_bc.nome'
              :cpntValue='campos.s_doc_bc.value'
              :cpntAutoComplete='campos.s_doc_bc.autocomplete'
              :cpntMask='campos.s_doc_bc.mask'
              :cpntOptionInicialNome='campos.s_doc_bc.optionInicialNome'
              :cpntOptionInicialValue='campos.s_doc_bc.optionInicialValue'
              :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_bc.disabled === true'
              :cpntMostrar='campos.s_doc_bc.mostrar'
              :cpntAutoFocus='campos.s_doc_bc.autofocus'
              :cpntMensagem='campos.s_doc_bc.mensagem'
              :cpntMensagemTipo='campos.s_doc_bc.mensagemTipo'
              :cpntPlaceholder='campos.s_doc_bc.placeholder'
              :cpntPosicionar='campos.s_doc_bc.posicionar'
              :cpntOnChange='campos.s_doc_bc.onChange'
              :cpntOnBlur='campos.s_doc_bc.onBlur'
              ref='s_doc_bc'
            ></App-Input>
          </div>

          <div>
            <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_iss_a"
              :cpntStatus='campos.s_doc_iss_a.status'
              :cpntId='campos.s_doc_iss_a.id'
              :cpntTabIndex='campos.s_doc_iss_a.tabIndex'
              :cpntClassDivField='campos.s_doc_iss_a.classDivField'
              :cpntNome='campos.s_doc_iss_a.nome'
              :cpntValue='campos.s_doc_iss_a.value'
              :cpntAutoComplete='campos.s_doc_iss_a.autocomplete'
              :cpntMask='campos.s_doc_iss_a.mask'
              :cpntOptionInicialNome='campos.s_doc_iss_a.optionInicialNome'
              :cpntOptionInicialValue='campos.s_doc_iss_a.optionInicialValue'
              :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_iss_a.disabled === true'
              :cpntMostrar='campos.s_doc_iss_a.mostrar'
              :cpntAutoFocus='campos.s_doc_iss_a.autofocus'
              :cpntMensagem='campos.s_doc_iss_a.mensagem'
              :cpntMensagemTipo='campos.s_doc_iss_a.mensagemTipo'
              :cpntPlaceholder='campos.s_doc_iss_a.placeholder'
              :cpntPosicionar='campos.s_doc_iss_a.posicionar'
              :cpntOnChange='campos.s_doc_iss_a.onChange'
              :cpntOnBlur='campos.s_doc_iss_a.onBlur'
              ref='s_doc_iss_a'
            ></App-Input>

            <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_iss_v"
              :cpntStatus='campos.s_doc_iss_v.status'
              :cpntId='campos.s_doc_iss_v.id'
              :cpntTabIndex='campos.s_doc_iss_v.tabIndex'
              :cpntClassDivField='campos.s_doc_iss_v.classDivField'
              :cpntNome='campos.s_doc_iss_v.nome'
              :cpntValue='campos.s_doc_iss_v.value'
              :cpntAutoComplete='campos.s_doc_iss_v.autocomplete'
              :cpntMask='campos.s_doc_iss_v.mask'
              :cpntOptionInicialNome='campos.s_doc_iss_v.optionInicialNome'
              :cpntOptionInicialValue='campos.s_doc_iss_v.optionInicialValue'
              :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_iss_v.disabled === true'
              :cpntMostrar='campos.s_doc_iss_v.mostrar'
              :cpntAutoFocus='campos.s_doc_iss_v.autofocus'
              :cpntMensagem='campos.s_doc_iss_v.mensagem'
              :cpntMensagemTipo='campos.s_doc_iss_v.mensagemTipo'
              :cpntPlaceholder='campos.s_doc_iss_v.placeholder'
              :cpntPosicionar='campos.s_doc_iss_v.posicionar'
              :cpntOnChange='campos.s_doc_iss_v.onChange'
              :cpntOnBlur='campos.s_doc_iss_v.onBlur'
              ref='s_doc_iss_v'
            ></App-Input>

              <App-Toggles :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_iss_flag_r"
              :cpntStatus='campos.s_doc_iss_flag_r.status'
              :cpntId='campos.s_doc_iss_flag_r.id'
              :cpntClassDivField='campos.s_doc_iss_flag_r.classDivField'
              :cpntNome='campos.s_doc_iss_flag_r.nome'
              :cpntValue='campos.s_doc_iss_flag_r.value'
              :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_iss_flag_r.disabled === true'
              :cpntMostrar='campos.s_doc_iss_flag_r.mostrar'
              :cpntMensagem='campos.s_doc_iss_flag_r.mensagem'
              :cpntMensagemTipo='campos.s_doc_iss_flag_r.mensagemTipo'
              :cpntOn='campos.s_doc_iss_flag_r.on'
              :cpntOff='campos.s_doc_iss_flag_r.off'
              :cpntExplica='campos.s_doc_iss_flag_r.explica'
              :cpntWidth='campos.s_doc_iss_flag_r.width'
              :cpntTabIndex='campos.s_doc_iss_flag_r.tabIndex'
              :cpntOnChange='campos.s_doc_iss_flag_r.onChange'
              :cpntOnBlur='campos.s_doc_iss_flag_r.onBlur'
              ref='s_doc_iss_flag_r'
            ></App-Toggles>
          </div>

          <div class="totais">
            <div>
              Retenções Federais
            </div>
          </div>

          <div class="msg-retencao" v-if="cpntSDocFlagSimplesPrestador === true && cpntSDocFlagSimplesTomador === true">
            <b>Prestador</b> e <b>Tomador</b> Optante pelo Simples Nacional (Isento)
          </div>
          <div class="msg-retencao" v-else-if="cpntSDocFlagSimplesTomador === true && cpntIdConPessoa === 'f'">
            <b>Tomador</b> do tipo pessoa física (Isento)
          </div>
          <div class="msg-retencao" v-else-if="cpntSDocFlagSimplesTomador === true && cpntIdConPessoa === 'j'">
            <b>Tomador</b> Optante pelo Simples Nacional (Isento)
          </div>
          <div class="msg-retencao" v-else-if="cpntSDocFlagSimplesPrestador === true">
            <b>Prestador</b> Optante pelo Simples Nacional (Isento)
          </div>

          <template v-else>
            <div>
              <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_pis_a"
                :cpntStatus='campos.s_doc_pis_a.status'
                :cpntId='campos.s_doc_pis_a.id'
                :cpntTabIndex='campos.s_doc_pis_a.tabIndex'
                :cpntClassDivField='campos.s_doc_pis_a.classDivField'
                :cpntNome='campos.s_doc_pis_a.nome'
                :cpntValue='campos.s_doc_pis_a.value'
                :cpntAutoComplete='campos.s_doc_pis_a.autocomplete'
                :cpntMask='campos.s_doc_pis_a.mask'
                :cpntOptionInicialNome='campos.s_doc_pis_a.optionInicialNome'
                :cpntOptionInicialValue='campos.s_doc_pis_a.optionInicialValue'
                :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_pis_a.disabled === true'
                :cpntMostrar='campos.s_doc_pis_a.mostrar'
                :cpntAutoFocus='campos.s_doc_pis_a.autofocus'
                :cpntMensagem='campos.s_doc_pis_a.mensagem'
                :cpntMensagemTipo='campos.s_doc_pis_a.mensagemTipo'
                :cpntPlaceholder='campos.s_doc_pis_a.placeholder'
                :cpntPosicionar='campos.s_doc_pis_a.posicionar'
                :cpntOnChange='campos.s_doc_pis_a.onChange'
                :cpntOnBlur='campos.s_doc_pis_a.onBlur'
                ref='s_doc_pis_a'
              ></App-Input>

              <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_pis_v"
                :cpntStatus='campos.s_doc_pis_v.status'
                :cpntId='campos.s_doc_pis_v.id'
                :cpntTabIndex='campos.s_doc_pis_v.tabIndex'
                :cpntClassDivField='campos.s_doc_pis_v.classDivField'
                :cpntNome='campos.s_doc_pis_v.nome'
                :cpntValue='campos.s_doc_pis_v.value'
                :cpntAutoComplete='campos.s_doc_pis_v.autocomplete'
                :cpntMask='campos.s_doc_pis_v.mask'
                :cpntOptionInicialNome='campos.s_doc_pis_v.optionInicialNome'
                :cpntOptionInicialValue='campos.s_doc_pis_v.optionInicialValue'
                :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_pis_v.disabled === true'
                :cpntMostrar='campos.s_doc_pis_v.mostrar'
                :cpntAutoFocus='campos.s_doc_pis_v.autofocus'
                :cpntMensagem='campos.s_doc_pis_v.mensagem'
                :cpntMensagemTipo='campos.s_doc_pis_v.mensagemTipo'
                :cpntPlaceholder='campos.s_doc_pis_v.placeholder'
                :cpntPosicionar='campos.s_doc_pis_v.posicionar'
                :cpntOnChange='campos.s_doc_pis_v.onChange'
                :cpntOnBlur='campos.s_doc_pis_v.onBlur'
                ref='s_doc_pis_v'
              ></App-Input>

              <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_cofins_a"
                :cpntStatus='campos.s_doc_cofins_a.status'
                :cpntId='campos.s_doc_cofins_a.id'
                :cpntTabIndex='campos.s_doc_cofins_a.tabIndex'
                :cpntClassDivField='campos.s_doc_cofins_a.classDivField'
                :cpntNome='campos.s_doc_cofins_a.nome'
                :cpntValue='campos.s_doc_cofins_a.value'
                :cpntAutoComplete='campos.s_doc_cofins_a.autocomplete'
                :cpntMask='campos.s_doc_cofins_a.mask'
                :cpntOptionInicialNome='campos.s_doc_cofins_a.optionInicialNome'
                :cpntOptionInicialValue='campos.s_doc_cofins_a.optionInicialValue'
                :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_cofins_a.disabled === true'
                :cpntMostrar='campos.s_doc_cofins_a.mostrar'
                :cpntAutoFocus='campos.s_doc_cofins_a.autofocus'
                :cpntMensagem='campos.s_doc_cofins_a.mensagem'
                :cpntMensagemTipo='campos.s_doc_cofins_a.mensagemTipo'
                :cpntPlaceholder='campos.s_doc_cofins_a.placeholder'
                :cpntPosicionar='campos.s_doc_cofins_a.posicionar'
                :cpntOnChange='campos.s_doc_cofins_a.onChange'
                :cpntOnBlur='campos.s_doc_cofins_a.onBlur'
                ref='s_doc_cofins_a'
              ></App-Input>

              <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_cofins_v"
                :cpntStatus='campos.s_doc_cofins_v.status'
                :cpntId='campos.s_doc_cofins_v.id'
                :cpntTabIndex='campos.s_doc_cofins_v.tabIndex'
                :cpntClassDivField='campos.s_doc_cofins_v.classDivField'
                :cpntNome='campos.s_doc_cofins_v.nome'
                :cpntValue='campos.s_doc_cofins_v.value'
                :cpntAutoComplete='campos.s_doc_cofins_v.autocomplete'
                :cpntMask='campos.s_doc_cofins_v.mask'
                :cpntOptionInicialNome='campos.s_doc_cofins_v.optionInicialNome'
                :cpntOptionInicialValue='campos.s_doc_cofins_v.optionInicialValue'
                :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_cofins_v.disabled === true'
                :cpntMostrar='campos.s_doc_cofins_v.mostrar'
                :cpntAutoFocus='campos.s_doc_cofins_v.autofocus'
                :cpntMensagem='campos.s_doc_cofins_v.mensagem'
                :cpntMensagemTipo='campos.s_doc_cofins_v.mensagemTipo'
                :cpntPlaceholder='campos.s_doc_cofins_v.placeholder'
                :cpntPosicionar='campos.s_doc_cofins_v.posicionar'
                :cpntOnChange='campos.s_doc_cofins_v.onChange'
                :cpntOnBlur='campos.s_doc_cofins_v.onBlur'
                ref='s_doc_cofins_v'
              ></App-Input>
            </div>

            <div>
              <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_csll_a"
                :cpntStatus='campos.s_doc_csll_a.status'
                :cpntId='campos.s_doc_csll_a.id'
                :cpntTabIndex='campos.s_doc_csll_a.tabIndex'
                :cpntClassDivField='campos.s_doc_csll_a.classDivField'
                :cpntNome='campos.s_doc_csll_a.nome'
                :cpntValue='campos.s_doc_csll_a.value'
                :cpntAutoComplete='campos.s_doc_csll_a.autocomplete'
                :cpntMask='campos.s_doc_csll_a.mask'
                :cpntOptionInicialNome='campos.s_doc_csll_a.optionInicialNome'
                :cpntOptionInicialValue='campos.s_doc_csll_a.optionInicialValue'
                :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_csll_a.disabled === true'
                :cpntMostrar='campos.s_doc_csll_a.mostrar'
                :cpntAutoFocus='campos.s_doc_csll_a.autofocus'
                :cpntMensagem='campos.s_doc_csll_a.mensagem'
                :cpntMensagemTipo='campos.s_doc_csll_a.mensagemTipo'
                :cpntPlaceholder='campos.s_doc_csll_a.placeholder'
                :cpntPosicionar='campos.s_doc_csll_a.posicionar'
                :cpntOnChange='campos.s_doc_csll_a.onChange'
                :cpntOnBlur='campos.s_doc_csll_a.onBlur'
                ref='s_doc_csll_a'
              ></App-Input>

              <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_csll_v"
                :cpntStatus='campos.s_doc_csll_v.status'
                :cpntId='campos.s_doc_csll_v.id'
                :cpntTabIndex='campos.s_doc_csll_v.tabIndex'
                :cpntClassDivField='campos.s_doc_csll_v.classDivField'
                :cpntNome='campos.s_doc_csll_v.nome'
                :cpntValue='campos.s_doc_csll_v.value'
                :cpntAutoComplete='campos.s_doc_csll_v.autocomplete'
                :cpntMask='campos.s_doc_csll_v.mask'
                :cpntOptionInicialNome='campos.s_doc_csll_v.optionInicialNome'
                :cpntOptionInicialValue='campos.s_doc_csll_v.optionInicialValue'
                :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_csll_v.disabled === true'
                :cpntMostrar='campos.s_doc_csll_v.mostrar'
                :cpntAutoFocus='campos.s_doc_csll_v.autofocus'
                :cpntMensagem='campos.s_doc_csll_v.mensagem'
                :cpntMensagemTipo='campos.s_doc_csll_v.mensagemTipo'
                :cpntPlaceholder='campos.s_doc_csll_v.placeholder'
                :cpntPosicionar='campos.s_doc_csll_v.posicionar'
                :cpntOnChange='campos.s_doc_csll_v.onChange'
                :cpntOnBlur='campos.s_doc_csll_v.onBlur'
                ref='s_doc_csll_v'
              ></App-Input>

              <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_irrf_a"
                :cpntStatus='campos.s_doc_irrf_a.status'
                :cpntId='campos.s_doc_irrf_a.id'
                :cpntTabIndex='campos.s_doc_irrf_a.tabIndex'
                :cpntClassDivField='campos.s_doc_irrf_a.classDivField'
                :cpntNome='campos.s_doc_irrf_a.nome'
                :cpntValue='campos.s_doc_irrf_a.value'
                :cpntAutoComplete='campos.s_doc_irrf_a.autocomplete'
                :cpntMask='campos.s_doc_irrf_a.mask'
                :cpntOptionInicialNome='campos.s_doc_irrf_a.optionInicialNome'
                :cpntOptionInicialValue='campos.s_doc_irrf_a.optionInicialValue'
                :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_irrf_a.disabled === true'
                :cpntMostrar='campos.s_doc_irrf_a.mostrar'
                :cpntAutoFocus='campos.s_doc_irrf_a.autofocus'
                :cpntMensagem='campos.s_doc_irrf_a.mensagem'
                :cpntMensagemTipo='campos.s_doc_irrf_a.mensagemTipo'
                :cpntPlaceholder='campos.s_doc_irrf_a.placeholder'
                :cpntPosicionar='campos.s_doc_irrf_a.posicionar'
                :cpntOnChange='campos.s_doc_irrf_a.onChange'
                :cpntOnBlur='campos.s_doc_irrf_a.onBlur'
                ref='s_doc_irrf_a'
              ></App-Input>

              <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_irrf_v"
                :cpntStatus='campos.s_doc_irrf_v.status'
                :cpntId='campos.s_doc_irrf_v.id'
                :cpntTabIndex='campos.s_doc_irrf_v.tabIndex'
                :cpntClassDivField='campos.s_doc_irrf_v.classDivField'
                :cpntNome='campos.s_doc_irrf_v.nome'
                :cpntValue='campos.s_doc_irrf_v.value'
                :cpntAutoComplete='campos.s_doc_irrf_v.autocomplete'
                :cpntMask='campos.s_doc_irrf_v.mask'
                :cpntOptionInicialNome='campos.s_doc_irrf_v.optionInicialNome'
                :cpntOptionInicialValue='campos.s_doc_irrf_v.optionInicialValue'
                :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_irrf_v.disabled === true'
                :cpntMostrar='campos.s_doc_irrf_v.mostrar'
                :cpntAutoFocus='campos.s_doc_irrf_v.autofocus'
                :cpntMensagem='campos.s_doc_irrf_v.mensagem'
                :cpntMensagemTipo='campos.s_doc_irrf_v.mensagemTipo'
                :cpntPlaceholder='campos.s_doc_irrf_v.placeholder'
                :cpntPosicionar='campos.s_doc_irrf_v.posicionar'
                :cpntOnChange='campos.s_doc_irrf_v.onChange'
                :cpntOnBlur='campos.s_doc_irrf_v.onBlur'
                ref='s_doc_irrf_v'
              ></App-Input>
            </div>

            <div>
              <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_inss_a"
                :cpntStatus='campos.s_doc_inss_a.status'
                :cpntId='campos.s_doc_inss_a.id'
                :cpntTabIndex='campos.s_doc_inss_a.tabIndex'
                :cpntClassDivField='campos.s_doc_inss_a.classDivField'
                :cpntNome='campos.s_doc_inss_a.nome'
                :cpntValue='campos.s_doc_inss_a.value'
                :cpntAutoComplete='campos.s_doc_inss_a.autocomplete'
                :cpntMask='campos.s_doc_inss_a.mask'
                :cpntOptionInicialNome='campos.s_doc_inss_a.optionInicialNome'
                :cpntOptionInicialValue='campos.s_doc_inss_a.optionInicialValue'
                :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_inss_a.disabled === true'
                :cpntMostrar='campos.s_doc_inss_a.mostrar'
                :cpntAutoFocus='campos.s_doc_inss_a.autofocus'
                :cpntMensagem='campos.s_doc_inss_a.mensagem'
                :cpntMensagemTipo='campos.s_doc_inss_a.mensagemTipo'
                :cpntPlaceholder='campos.s_doc_inss_a.placeholder'
                :cpntPosicionar='campos.s_doc_inss_a.posicionar'
                :cpntOnChange='campos.s_doc_inss_a.onChange'
                :cpntOnBlur='campos.s_doc_inss_a.onBlur'
                ref='s_doc_inss_a'
              ></App-Input>

              <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_inss_v"
                :cpntStatus='campos.s_doc_inss_v.status'
                :cpntId='campos.s_doc_inss_v.id'
                :cpntTabIndex='campos.s_doc_inss_v.tabIndex'
                :cpntClassDivField='campos.s_doc_inss_v.classDivField'
                :cpntNome='campos.s_doc_inss_v.nome'
                :cpntValue='campos.s_doc_inss_v.value'
                :cpntAutoComplete='campos.s_doc_inss_v.autocomplete'
                :cpntMask='campos.s_doc_inss_v.mask'
                :cpntOptionInicialNome='campos.s_doc_inss_v.optionInicialNome'
                :cpntOptionInicialValue='campos.s_doc_inss_v.optionInicialValue'
                :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_inss_v.disabled === true'
                :cpntMostrar='campos.s_doc_inss_v.mostrar'
                :cpntAutoFocus='campos.s_doc_inss_v.autofocus'
                :cpntMensagem='campos.s_doc_inss_v.mensagem'
                :cpntMensagemTipo='campos.s_doc_inss_v.mensagemTipo'
                :cpntPlaceholder='campos.s_doc_inss_v.placeholder'
                :cpntPosicionar='campos.s_doc_inss_v.posicionar'
                :cpntOnChange='campos.s_doc_inss_v.onChange'
                :cpntOnBlur='campos.s_doc_inss_v.onBlur'
                ref='s_doc_inss_v'
              ></App-Input>

              <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_r_outros_v"
                :cpntStatus='campos.s_doc_r_outros_v.status'
                :cpntId='campos.s_doc_r_outros_v.id'
                :cpntTabIndex='campos.s_doc_r_outros_v.tabIndex'
                :cpntClassDivField='campos.s_doc_r_outros_v.classDivField'
                :cpntNome='campos.s_doc_r_outros_v.nome'
                :cpntValue='campos.s_doc_r_outros_v.value'
                :cpntAutoComplete='campos.s_doc_r_outros_v.autocomplete'
                :cpntMask='campos.s_doc_r_outros_v.mask'
                :cpntOptionInicialNome='campos.s_doc_r_outros_v.optionInicialNome'
                :cpntOptionInicialValue='campos.s_doc_r_outros_v.optionInicialValue'
                :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_r_outros_v.disabled === true'
                :cpntMostrar='campos.s_doc_r_outros_v.mostrar'
                :cpntAutoFocus='campos.s_doc_r_outros_v.autofocus'
                :cpntMensagem='campos.s_doc_r_outros_v.mensagem'
                :cpntMensagemTipo='campos.s_doc_r_outros_v.mensagemTipo'
                :cpntPlaceholder='campos.s_doc_r_outros_v.placeholder'
                :cpntPosicionar='campos.s_doc_r_outros_v.posicionar'
                :cpntOnChange='campos.s_doc_r_outros_v.onChange'
                :cpntOnBlur='campos.s_doc_r_outros_v.onBlur'
                ref='s_doc_r_outros_v'
              ></App-Input>
            </div>
          </template>
        </template>
      </template>

      <template v-if="$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 40 ], null, false) === true">
        <div class="totais">
          <div>
            Totais
          </div>
        </div>

        <div>
          <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--retencoes"
            :cpntStatus='campos.retencoes.status'
            :cpntId='campos.retencoes.id'
            :cpntTabIndex='campos.retencoes.tabIndex'
            :cpntClassDivField='campos.retencoes.classDivField'
            :cpntNome='campos.retencoes.nome'
            :cpntValue='campos.retencoes.value'
            :cpntAutoComplete='campos.retencoes.autocomplete'
            :cpntMask='campos.retencoes.mask'
            :cpntOptionInicialNome='campos.retencoes.optionInicialNome'
            :cpntOptionInicialValue='campos.retencoes.optionInicialValue'
            :cpntDisabled='cpntSDocNFEmitida === true || campos.retencoes.disabled === true'
            :cpntMostrar='campos.retencoes.mostrar'
            :cpntAutoFocus='campos.retencoes.autofocus'
            :cpntMensagem='campos.retencoes.mensagem'
            :cpntMensagemTipo='campos.retencoes.mensagemTipo'
            :cpntPlaceholder='campos.retencoes.placeholder'
            :cpntPosicionar='campos.retencoes.posicionar'
            :cpntOnChange='campos.retencoes.onChange'
            :cpntOnBlur='campos.retencoes.onBlur'
            ref='retencoes'
          ></App-Input>

          <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_vTLiquido"
            :cpntStatus='campos.s_doc_vTLiquido.status'
            :cpntId='campos.s_doc_vTLiquido.id'
            :cpntTabIndex='campos.s_doc_vTLiquido.tabIndex'
            :cpntClassDivField='campos.s_doc_vTLiquido.classDivField'
            :cpntNome='campos.s_doc_vTLiquido.nome'
            :cpntValue='campos.s_doc_vTLiquido.value'
            :cpntAutoComplete='campos.s_doc_vTLiquido.autocomplete'
            :cpntMask='campos.s_doc_vTLiquido.mask'
            :cpntOptionInicialNome='campos.s_doc_vTLiquido.optionInicialNome'
            :cpntOptionInicialValue='campos.s_doc_vTLiquido.optionInicialValue'
            :cpntDisabled='cpntSDocNFEmitida === true || campos.s_doc_vTLiquido.disabled === true'
            :cpntMostrar='campos.s_doc_vTLiquido.mostrar'
            :cpntAutoFocus='campos.s_doc_vTLiquido.autofocus'
            :cpntMensagem='campos.s_doc_vTLiquido.mensagem'
            :cpntMensagemTipo='campos.s_doc_vTLiquido.mensagemTipo'
            :cpntPlaceholder='campos.s_doc_vTLiquido.placeholder'
            :cpntPosicionar='campos.s_doc_vTLiquido.posicionar'
            :cpntOnChange='campos.s_doc_vTLiquido.onChange'
            :cpntOnBlur='campos.s_doc_vTLiquido.onBlur'
            ref='s_doc_vTLiquido'
          ></App-Input>
        </div>
      </template>
    </template>

    <template v-else>
      <div v-if="[ 'ND', 'NFS', 'NFSe(m)' ].indexOf(cpntSDocTp) !== -1">
        <App-Calendario :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_emi"
          :cpntStatus='campos.s_doc_emi.status'
          :cpntId='campos.s_doc_emi.id'
          :cpntTabIndex='campos.s_doc_emi.tabIndex'
          :cpntClassDivField='campos.s_doc_emi.classDivField'
          :cpntNome='campos.s_doc_emi.nome'
          :cpntValue='campos.s_doc_emi.value'
          :cpntAutoComplete='campos.s_doc_emi.autocomplete'
          :cpntMask='campos.s_doc_emi.mask'
          :cpntDisabled='campos.s_doc_emi.disabled'
          :cpntMostrar='campos.s_doc_emi.mostrar'
          :cpntAutoFocus='campos.s_doc_emi.autofocus'
          :cpntMensagem='campos.s_doc_emi.mensagem'
          :cpntMensagemTipo='campos.s_doc_emi.mensagemTipo'
          :cpntPlaceholder='campos.s_doc_emi.placeholder'
          :cpntPosicionar='campos.s_doc_emi.posicionar'
          :cpntOnChange='campos.s_doc_emi.onChange'
          ref='s_doc_emi'
        ></App-Calendario>
      </div>

      <div v-if="[ '' ].indexOf(cpntSDocTp) === -1">
        <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_cv" v-if="[ 'ND' ].indexOf(cpntSDocTp) === -1 && [ 'NFSe(m)' ].indexOf(cpntSDocTp) !== -1"
          :cpntStatus='campos.s_doc_cv.status'
          :cpntId='campos.s_doc_cv.id'
          :cpntTabIndex='campos.s_doc_cv.tabIndex'
          :cpntClassDivField='campos.s_doc_cv.classDivField'
          :cpntNome='campos.s_doc_cv.nome'
          :cpntValue='campos.s_doc_cv.value'
          :cpntAutoComplete='campos.s_doc_cv.autocomplete'
          :cpntMask='campos.s_doc_cv.mask'
          :cpntOptionInicialNome='campos.s_doc_cv.optionInicialNome'
          :cpntOptionInicialValue='campos.s_doc_cv.optionInicialValue'
          :cpntDisabled='campos.s_doc_cv.disabled'
          :cpntMostrar='campos.s_doc_cv.mostrar'
          :cpntAutoFocus='campos.s_doc_cv.autofocus'
          :cpntMensagem='campos.s_doc_cv.mensagem'
          :cpntMensagemTipo='campos.s_doc_cv.mensagemTipo'
          :cpntPlaceholder='campos.s_doc_cv.placeholder'
          :cpntPosicionar='campos.s_doc_cv.posicionar'
          :cpntOnChange='campos.s_doc_cv.onChange'
          :cpntOnBlur='campos.s_doc_cv.onBlur'
          ref='s_doc_cv'
        ></App-Input>

        <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_n"
          :cpntStatus='campos.s_doc_n.status'
          :cpntId='campos.s_doc_n.id'
          :cpntTabIndex='campos.s_doc_n.tabIndex'
          :cpntClassDivField='campos.s_doc_n.classDivField'
          :cpntNome='campos.s_doc_n.nome'
          :cpntValue='campos.s_doc_n.value'
          :cpntAutoComplete='campos.s_doc_n.autocomplete'
          :cpntMask='campos.s_doc_n.mask'
          :cpntOptionInicialNome='campos.s_doc_n.optionInicialNome'
          :cpntOptionInicialValue='campos.s_doc_n.optionInicialValue'
          :cpntDisabled='campos.s_doc_n.disabled'
          :cpntMostrar='campos.s_doc_n.mostrar'
          :cpntAutoFocus='campos.s_doc_n.autofocus'
          :cpntMensagem='campos.s_doc_n.mensagem'
          :cpntMensagemTipo='campos.s_doc_n.mensagemTipo'
          :cpntPlaceholder='campos.s_doc_n.placeholder'
          :cpntPosicionar='campos.s_doc_n.posicionar'
          :cpntOnChange='campos.s_doc_n.onChange'
          :cpntOnBlur='campos.s_doc_n.onBlur'
          ref='s_doc_n'
        ></App-Input>

        <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_s" v-if="[ 'ND' ].indexOf(cpntSDocTp) === -1"
          :cpntStatus='campos.s_doc_s.status'
          :cpntId='campos.s_doc_s.id'
          :cpntTabIndex='campos.s_doc_s.tabIndex'
          :cpntClassDivField='campos.s_doc_s.classDivField'
          :cpntNome='campos.s_doc_s.nome'
          :cpntValue='campos.s_doc_s.value'
          :cpntAutoComplete='campos.s_doc_s.autocomplete'
          :cpntMask='campos.s_doc_s.mask'
          :cpntOptionInicialNome='campos.s_doc_s.optionInicialNome'
          :cpntOptionInicialValue='campos.s_doc_s.optionInicialValue'
          :cpntDisabled='campos.s_doc_s.disabled'
          :cpntMostrar='campos.s_doc_s.mostrar'
          :cpntAutoFocus='campos.s_doc_s.autofocus'
          :cpntMensagem='campos.s_doc_s.mensagem'
          :cpntMensagemTipo='campos.s_doc_s.mensagemTipo'
          :cpntPlaceholder='campos.s_doc_s.placeholder'
          :cpntPosicionar='campos.s_doc_s.posicionar'
          :cpntOnChange='campos.s_doc_s.onChange'
          :cpntOnBlur='campos.s_doc_s.onBlur'
          ref='s_doc_s'
        ></App-Input>
      </div>

      <div>
        <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_ret" v-if="[ 'NFS', 'NFSe(m)' ].indexOf(cpntSDocTp) !== -1"
          :cpntStatus='campos.s_doc_ret.status'
          :cpntId='campos.s_doc_ret.id'
          :cpntTabIndex='campos.s_doc_ret.tabIndex'
          :cpntClassDivField='campos.s_doc_ret.classDivField'
          :cpntNome='campos.s_doc_ret.nome'
          :cpntValue='campos.s_doc_ret.value'
          :cpntAutoComplete='campos.s_doc_ret.autocomplete'
          :cpntMask='campos.s_doc_ret.mask'
          :cpntOptionInicialNome='campos.s_doc_ret.optionInicialNome'
          :cpntOptionInicialValue='campos.s_doc_ret.optionInicialValue'
          :cpntDisabled='campos.s_doc_ret.disabled'
          :cpntMostrar='campos.s_doc_ret.mostrar'
          :cpntAutoFocus='campos.s_doc_ret.autofocus'
          :cpntMensagem='campos.s_doc_ret.mensagem'
          :cpntMensagemTipo='campos.s_doc_ret.mensagemTipo'
          :cpntPlaceholder='campos.s_doc_ret.placeholder'
          :cpntPosicionar='campos.s_doc_ret.posicionar'
          :cpntOnChange='campos.s_doc_ret.onChange'
          :cpntOnBlur='campos.s_doc_ret.onBlur'
          ref='s_doc_ret'
        ></App-Input>

        <App-Input :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_des"  :style="cpntSDocTp === '' ? 'width: 100%;' : ''"
          :cpntStatus='campos.s_doc_des.status'
          :cpntId='campos.s_doc_des.id'
          :cpntTabIndex='campos.s_doc_des.tabIndex'
          :cpntClassDivField='campos.s_doc_des.classDivField'
          :cpntNome='campos.s_doc_des.nome'
          :cpntValue='campos.s_doc_des.value'
          :cpntAutoComplete='campos.s_doc_des.autocomplete'
          :cpntMask='campos.s_doc_des.mask'
          :cpntOptionInicialNome='campos.s_doc_des.optionInicialNome'
          :cpntOptionInicialValue='campos.s_doc_des.optionInicialValue'
          :cpntDisabled='campos.s_doc_des.disabled'
          :cpntMostrar='campos.s_doc_des.mostrar'
          :cpntAutoFocus='campos.s_doc_des.autofocus'
          :cpntMensagem='campos.s_doc_des.mensagem'
          :cpntMensagemTipo='campos.s_doc_des.mensagemTipo'
          :cpntPlaceholder='campos.s_doc_des.placeholder'
          :cpntExplica='campos.s_doc_des.explica'
          :cpntPosicionar='campos.s_doc_des.posicionar'
          :cpntOnChange='campos.s_doc_des.onChange'
          :cpntOnBlur='campos.s_doc_des.onBlur'
          ref='s_doc_des'
        ></App-Input>
      </div>
    </template>
  </div>
</template>

<style scoped>
.dem-edi-ser-doc-campos {
  padding: 23px 10px 15px 10px;
}
  .dem-edi-ser-doc-campos > div,
  .dem-edi-ser-doc-campos > div > div {
    width: 100%;
  }
  .dem-edi-ser-doc-campos > div:not(:first-child) {
    padding-top: 22px;
  }

  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_cod_tri {
    width: 150px;
    margin-right: 10px;
  }
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_mun_pre_ser {
    width: calc(100% - 150px - 10px);
  }
  .dem-edi-ser-doc-campos > div.totais > div {
    margin-top: -10px;
    text-align: center;
    background: #d9d9d9;
    border: 1px solid #c9c9c9;
    padding: 5px;
    border-radius: 5px;
    font-weight: 700;
    opacity: .8;
  }
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_vTServico,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_deducao_bc,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_desconto,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_iss_a,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_iss_v {
    width: calc((100% / 4) - (30px / 4));
    margin-right: 10px;
  }
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_vTServico,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_deducao_bc,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_desconto {
    width: calc((100% / 4) - (30px / 4));
    margin-right: 10px;
  }
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_bc {
    width: calc((100% / 4) - (30px / 4));
  }
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_iss_a,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_iss_v {
    width: calc((100% / 3) - (20px / 3));
    margin-right: 10px;
  }
  
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_iss_flag_r {
    width: calc((100% / 3) - (20px / 3));
  }
  /* .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--retencoes {
    margin-top: -15px !important;
  } */

  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_pis_a,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_pis_v,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_cofins_a,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_cofins_v,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_csll_a,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_csll_v,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_irrf_a,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_irrf_v {
    width: calc((100% / 4) - (30px / 4));
  }
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_pis_a,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_pis_v,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_cofins_a,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_csll_a,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_csll_v,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_irrf_a {
    margin-right: 10px;
  }

  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_inss_a,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_inss_v,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_r_outros_v {
    width: calc((100% / 3) - (20px / 3));
  }
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_inss_a,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_inss_v {
    margin-right: 10px;
  }

  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--retencoes,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_vTLiquido {
    width: calc((100% / 2) - (10px / 2));
  }
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--retencoes {
    margin-right: 10px;
  }

  .msg-retencao {
    color: red;
    text-align: center;
    margin-top: -12px;
  }

  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_cv,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_n,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_ret {
    margin-right: 10px;
  }
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_ret,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_des {
    width: calc((100% / 2) - (10px / 2));
  }

  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_emi,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_cv {
    width: 130px;
  }
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_n {
    width: 100px;
  }
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_s {
    width: 100px;
  }
</style>

<style>
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_vTServico > input,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_deducao_bc > input,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_desconto > input,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_iss_a > input,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_iss_v > input,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_bc > input,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_iss_flag_r > input,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_pis_a > input,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_pis_v > input,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_cofins_a > input,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_cofins_v > input,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_csll_a > input,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_csll_v > input,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_irrf_a > input,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_irrf_v > input,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_inss_a > input,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_inss_v > input,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_r_outros_v > input,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--retencoes > input,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--s_doc_vTLiquido > input {
    text-align: center;
  }
  /* .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--retencoes > tbody > tr > td.col_imp {
    padding-right: 10px;
    text-align: right;
  }
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--retencoes > tbody > tr > td.col_ali,
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--retencoes > tbody > tr > td.col_val {
    width: 130px;
    padding: 3px;
  }
  .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--retencoes > tbody > tr:last-child > td.col_ali {
    text-align: right;
  }
    .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--retencoes > tbody > tr > td.col_ali > div,
    .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--retencoes > tbody > tr > td.col_val > div {
      width: 85%;
      margin: 0px auto;
    }
      .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--retencoes > tbody > tr > td.col_ali > div > span > div > input,
      .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--retencoes > tbody > tr > td.col_val > div > span > div > input {
        text-align: center;
      }
      .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--retencoes > tbody > tr > td.col_ali > div > span > div,
      .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--retencoes > tbody > tr > td.col_val > div > span > div {
        width: calc(100% - 20px);
        display: inline-block;
        vertical-align: 0px;
      }
      .dem-edi-ser-doc-campos > div > .dem-edi-ser-doc--retencoes > tbody > tr > td.col_ali > div > span > div {
        margin-right: 3px;
      } */
</style>

<script>
  export default {
    props: {
      cpntDemandaId: {
        required: true
      },
      cpntDemandaTotal: {
        required: false
      },
      cpntSDocNFEmitida: {
        required: false
      },
      cpntMostrarDetalhes: {
        required: false
      },
      cpntSDocTp: {
        required: true
      },

      cpntIdConPessoa: {
        required: false
      },
      cpntSDocFlagSimplesPrestador: {
        required: false
      },
      cpntSDocFlagSimplesTomador: {
        required: false
      },

      cpntSDocNatOpe: {
        required: false
      },
      cpntSDocRamoAtiv: {
        required: false
      },
      cpntSDocAtividade: {
        required: false
      },
      cpntSDocCodTrib: {
        required: false
      },
      cpntSDocMunicipioPrestacao: {
        required: false
      },
      cpntSDocDescricao: {
        required: false
      },
      cpntSDocTotalServico: {
        required: false
      },
      cpntSDocDeducaoBC: {
        required: false
      },
      cpntSDocDesconto: {
        required: false
      },
      cpntSDocBaseCalculo: {
        required: false
      },
      cpntSDocIssAliquota: {
        required: false
      },
      cpntSDocFlagReterIss: {
        required: false
      },
      cpntSDocValorLiquido: {
        required: false
      },
      cpntSDocPisAliquota: {
        required: false
      },
      cpntSDocPisValor: {
        required: false
      },
      cpntSDocCofinsAliquota: {
        required: false
      },
      cpntSDocCofinsValor: {
        required: false
      },
      cpntSDocCsllAliquota: {
        required: false
      },
      cpntSDocCsllValor: {
        required: false
      },
      cpntSDocIrrfAliquota: {
        required: false
      },
      cpntSDocIrrfValor: {
        required: false
      },
      cpntSDocInssAliquota: {
        required: false
      },
      cpntSDocInssValor: {
        required: false
      },
      cpntSDocOutrasRetencoesValor: {
        required: false
      },

      cpntSDocManualCodVerificacao: {
        required: false
      },
      cpntSDocManualDesconto: {
        required: false
      },
      cpntSDocManualDataEmissao: {
        required: false
      },
      cpntSDocManualNumero: {
        required: false
      },
      cpntSDocManualSerie: {
        required: false
      },
      cpntSDocManualRetencao: {
        required: false
      },
    },
    components: {
      'App-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        campos: {
          s_doc_nat_ope: {
            id: 'dem-edi-ser-doc--s_doc_nat_ope',
            status: '',
            tabIndex: 17032001,
            nome: 'Natureza da Operação',
            keyValue: 'id',
            keyMostra: [ 'id', ' - ', 'nome' ],
            options: [],
            apiEnv: 'nat_ope',
            mostrar: true,
            searchMinimo: 4,
            value: '',
            onBuscarOptions: this.demEdiSerDocConOnBuscarNaturezaOperacao,
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_ramo_id: {
            id: 'dem-edi-ser-doc--s_doc_ramo_id',
            status: '',
            tabIndex: 17032002,
            nome: 'Ramo de Atividade',
            keyValue: 'cnae',
            keyMostra: [ 'cnae', ' - ', 'nome' ],
            options: [],
            apiEnv: 'ramo_id',
            mostrar: true,
            searchMinimo: 4,
            value: '',
            onBuscarOptions: this.demEdiSerDocConOnBuscarRamoAtividade,
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_ati_id: {
            id: 'dem-edi-ser-doc--s_doc_ati_id',
            status: '',
            tabIndex: 17032003,
            nome: 'Atividade',
            keyValue: 'id',
            keyMostra: [ 'id', ' - ', 'nome' ],
            options: [],
            apiEnv: 'ati_id',
            mostrar: true,
            searchMinimo: 4,
            value: '',
            onBuscarOptions: this.demEdiSerDocConOnBuscarAtividade,
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_cod_tri: {
            id: 'dem-edi-ser-doc--s_doc_cod_tri',
            status: '',
            tabIndex: 17032004,
            nome: 'Código Tributação',
            apiEnv: 'cod_tri',
            value: '',
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_mun_pre_ser: {
            id: 'dem-edi-ser-doc--s_doc_mun_pre_ser',
            status: '',
            tabIndex: 17032005,
            nome: 'Município de Prestação',
            method: 'GET',
            router: '/referencia/cep-cidade/get/',
            field: { id: null, cidade: null, uf: null, cod_ibge: null },
            where: { o: 's.ft', v: '#BUSCA#' },
            keyValue: 'cod_ibge',
            keyMostra: [ 'cidade', '/', 'uf' ],
            explica: { mensagem: 'Cidade/UF aonde será prestado o serviço', posicaoMy: 'top right', posicaoAt: 'bottom left' },
            valueRef: '',
            mostrar: true,
            apiEnv: 'mun_pre_ser',
            value: '',
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_descricao: {
            id: 'dem-edi-ser-doc--s_doc_descricao',
            status: '',
            tabIndex: 17032006,
            nome: 'Descrição',
            apiEnv: 'descricao',
            value: '',
            onChange: this.demEdiSerDocConOnChangeValue
          },
          // s_doc_deducao_bc: {
          //   id: 'dem-edi-ser-doc--s_doc_deducao_bc',
          //   status: '',
          //   tabIndex: 17032007,
          //   nome: 'Dedução BC',
          //   mask: 'valorMoeda',
          //   disabled: false,
          //   apiEnv: 's_doc_deducao_bc',
          //   value: '',
          //   onChange: this.demEdiSerDocConOnChangeValue
          // },
          s_doc_deducao_bc: {
            id: 'dem-edi-ser-doc--s_doc_deducao_bc',
            status: '',
            tabIndex: 17032007,
            nome: 'Dedução BC',
            mask: 'valorMoeda',
            apiEnv: 'deducao_bc',
            value: '',
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_vTServico: {
            id: 'dem-edi-ser-doc--s_doc_vTServico',
            status: '',
            tabIndex: 17032007,
            nome: 'Total Serviço',
            mask: 'valorMoeda',
            disabled: true,
            apiEnv: 's_doc_vTServico',
            value: '',
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_desconto: {
            id: 'dem-edi-ser-doc--s_doc_desconto',
            status: '',
            tabIndex: 17032008,
            nome: 'Desconto',
            mask: 'valorMoeda',
            apiEnv: 'desconto',
            value: '',
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_bc: {
            id: 'dem-edi-ser-doc--s_doc_bc',
            status: '',
            tabIndex: 17032009,
            nome: 'Base Cálculo',
            mask: 'valorMoeda',
            disabled: true,
            apiEnv: 's_doc_bc',
            value: '',
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_iss_a: {
            id: 'dem-edi-ser-doc--s_doc_iss_a',
            status: '',
            tabIndex: 17032010,
            nome: 'ISS Aliquota %',
            mask: 'VALOR_DECIMAL_CAMPO',
            apiEnv: 'iss_a',
            value: '',
            explica: { mensagem: 'ISS ou ISSQN significa Imposto Sobre Serviços de Qualquer Natureza, de competência dos Municípios e do Distrito Federal, tem como fato gerador deste imposto a prestação de serviços. O ISS varia de município para município e de acordo com o tipo de serviço prestado.', posicaoMy: 'top right', posicaoAt: 'bottom left' },
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_iss_v: {
            id: 'dem-edi-ser-doc--s_doc_iss_v',
            status: '',
            tabIndex: 17032011,
            nome: 'ISS Valor',
            mask: 'valorMoeda',
            disabled: true,
            value: '',
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_iss_flag_r: {
            id: 'dem-edi-ser-doc--s_doc_iss_flag_r',
            status: '',
            tabIndex: 17032012,
            nome: 'ISS de Retido',
            mask: 'valorMoeda',
            apiEnv: 'iss_flag_r',
            value: '',
            explica: { mensagem: 'Marque sim, caso o ISS será retido na fonte.', posicaoMy: 'top right', posicaoAt: 'bottom left' },
            onChange: this.demEdiSerDocConOnChangeValue
          },


          s_doc_pis_a: {
            id: 'dem-edi-ser-doc--s_doc_pis_a',
            status: '',
            tabIndex: 17032013,
            nome: 'PIS %',
            mask: 'VALOR_DECIMAL_CAMPO',
            apiEnv: 'r_pis_a',
            value: '',
            explica: { mensagem: 'PIS é a sigla para Programa de Integração Social, uma contribuição tributária de caráter social, que tem como objetivo financiar o pagamento do seguro-desemprego, abono e participação na receita dos órgãos e entidades, tanto para os trabalhadores de empresas públicas, como privadas.', posicaoMy: 'top right', posicaoAt: 'bottom left' },
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_pis_v: {
            id: 'dem-edi-ser-doc--s_doc_pis_v',
            status: '',
            tabIndex: 17032014,
            nome: 'PIS R$',
            mask: 'valorMoeda',
            disabled: true,
            value: '',
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_cofins_a: {
            id: 'dem-edi-ser-doc--s_doc_cofins_a',
            status: '',
            tabIndex: 17032015,
            nome: 'COFINS %',
            mask: 'VALOR_DECIMAL_CAMPO',
            apiEnv: 'r_cofins_a',
            value: '',
            explica: { mensagem: 'COFINS é a sigla de Contribuição para o Financiamento da Seguridade Social, que é uma contribuição social aplicada sobre o valor bruto apresentado por uma empresa. Como o próprio nome indica, a COFINS tem como o objetivo financiar a Seguridade Social, ou seja, areas fundamentais como a Previdência Social, Assistência Social e Saúde Pública.', posicaoMy: 'top right', posicaoAt: 'bottom left' },
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_cofins_v: {
            id: 'dem-edi-ser-doc--s_doc_cofins_v',
            status: '',
            tabIndex: 17032016,
            nome: 'COFINS R$',
            mask: 'valorMoeda',
            disabled: true,
            value: '',
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_csll_a: {
            id: 'dem-edi-ser-doc--s_doc_csll_a',
            status: '',
            tabIndex: 17032017,
            nome: 'CSLL %',
            mask: 'VALOR_DECIMAL_CAMPO',
            apiEnv: 'r_csll_a',
            value: '',
            explica: { mensagem: 'A CSLL - Contribuição Social sobre o Lucro Líquido é uma contribuição para apoiar financeiramente a Seguridade Social.', posicaoMy: 'top right', posicaoAt: 'bottom left' },
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_csll_v: {
            id: 'dem-edi-ser-doc--s_doc_csll_v',
            status: '',
            tabIndex: 17032018,
            nome: 'CSLL R$',
            mask: 'valorMoeda',
            disabled: true,
            value: '',
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_irrf_a: {
            id: 'dem-edi-ser-doc--s_doc_irrf_a',
            status: '',
            tabIndex: 17032019,
            nome: 'IRRF %',
            mask: 'VALOR_DECIMAL_CAMPO',
            apiEnv: 'r_irrf_a',
            value: '',
            explica: { mensagem: 'Imposto de Renda Retido na Fonte significa o valor anual descontado do rendimento do trabalhador ou da empresa e entregue ao governo federal, sendo que a porcentagem de desconto é fixada pelo governo de cada país onde é aplicado tal imposto.', posicaoMy: 'top right', posicaoAt: 'bottom left' },
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_irrf_v: {
            id: 'dem-edi-ser-doc--s_doc_irrf_v',
            status: '',
            tabIndex: 17032020,
            nome: 'IRRF R$',
            mask: 'valorMoeda',
            disabled: true,
            value: '',
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_inss_a: {
            id: 'dem-edi-ser-doc--s_doc_inss_a',
            status: '',
            tabIndex: 17032021,
            nome: 'INSS %',
            mask: 'VALOR_DECIMAL_CAMPO',
            apiEnv: 'r_inss_a',
            value: '',
            explica: { mensagem: 'INSS é a sigla de Instituto Nacional do Seguro Social, é um órgão do Ministério da Previdência Social, ligado diretamente ao Governo. O INSS é o órgão responsável por receber as contribuições dos indivíduos, e tem como função fazer os pagamentos de aposentadorias, auxílio-doença, pensão por morte, auxílio-acidente, e outros vários benefícios previsto por lei.', posicaoMy: 'top right', posicaoAt: 'bottom left' },
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_inss_v: {
            id: 'dem-edi-ser-doc--s_doc_inss_v',
            status: '',
            tabIndex: 17032022,
            nome: 'INSS R$',
            mask: 'valorMoeda',
            disabled: true,
            value: '',
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_r_outros_v: {
            id: 'dem-edi-ser-doc--s_doc_r_outros_v',
            status: '',
            tabIndex: 17032023,
            nome: 'Outras Retenções',
            mask: 'valorMoeda',
            apiEnv: 'r_outros_v',
            value: '',
            onChange: this.demEdiSerDocConOnChangeValue
          },
          retencoes: {
            id: 'dem-edi-ser-doc--retencoes',
            status: '',
            tabIndex: 17032024,
            nome: 'Total Retido R$',
            mask: 'valorMoeda',
            disabled: true,
            value: '',
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_vTLiquido: {
            id: 'dem-edi-ser-doc--s_doc_vTLiquido',
            status: '',
            tabIndex: 17032025,
            nome: 'Total Líquido R$',
            mask: 'valorMoeda',
            disabled: true,
            value: '',
            onChange: this.demEdiSerDocConOnChangeValue
          },

          // CAMPOS PARA UTILIZAÇÃO SEM NFS-E
          s_doc_emi: {
            id: 'dem-edi-ser-doc--s_doc_emi',
            status: '',
            tabIndex: 17032026,
            nome: 'Data da Emissão',
            value: '',
            apiEnv: 's_doc_emi',
            explica: { mensagem: 'Data da emissão do documento.' },
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_cv: {
            id: 'dem-edi-ser-doc--s_doc_cv',
            status: '',
            tabIndex: 17032027,
            nome: 'Cód. Verificação',
            value: '',
            apiEnv: 's_doc_cv',
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_n: {
            id: 'dem-edi-ser-doc--s_doc_n',
            status: '',
            tabIndex: 17032028,
            nome: 'Número',
            value: '',
            apiEnv: 's_doc_n',
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_s: {
            id: 'dem-edi-ser-doc--s_doc_s',
            status: '',
            tabIndex: 17032029,
            nome: 'Série',
            value: '',
            apiEnv: 's_doc_s',
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_ret: {
            id: 'dem-edi-ser-doc--s_doc_ret',
            status: '',
            tabIndex: 17032030,
            nome: 'Retenção',
            mask: 'valorMoeda',
            value: '',
            apiEnv: 's_doc_ret',
            onChange: this.demEdiSerDocConOnChangeValue
          },
          s_doc_des: {
            id: 'dem-edi-ser-doc--s_doc_des',
            status: '',
            tabIndex: 17032031,
            nome: 'Desconto',
            mask: 'valorMoeda',
            value: '',
            apiEnv: 's_doc_des',
            explica: { mensagem: 'Desconto total em R$.' },
            onChange: this.demEdiSerDocConOnChangeValue
          }
        },
        abasVet: {},
        abasVal: ''
      }
    },
    mounted: function () {
      this.demEdiSerDocConIniciar()
    },
    methods: {
      demEdiSerDocConIniciar: function () {
        // SETA O STATUS DA TELA
        this.demEdiSerDocConSetarStatusGeral('carregando')

        // PEGA O NOME DE CADA CHAVE QUE DEVE SETAR O VALOR
        var chaves = Object.keys(this.campos)

        // RODA O VETOR DOS CAMPOS
        for (var indexC in chaves) {
          // SETA O NOME DA CHAVE QUE SERÁ TRABALHADA
          var chave = chaves[indexC]

          // SETA OS VALORES DO CAMPO
          this.demEdiSerDocConSetarValorCampo(chave, true)

          // SETA O VALOR INICIAL DO CAMPO
          this.campos[chave].valueIni = this.campos[chave].value
        }

        // SETA O STATUS DA TELA
        this.demEdiSerDocConSetarStatusGeral('')
      },
      demEdiSerDocConSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiSerDocConOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')

        // SETA O VALOR RECEBIDO
        this.$set(this.campos[indexF[1]], 'value', value)

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF[1]], 'mensagem', '')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA A AÇÃO DO CAMPO
        switch (indexF[1]) {
          case 's_doc_iss_flag_r':
            this.demEdiSerDocConCalcularValorLiquido()
            break

          case 's_doc_deducao_bc':
          case 's_doc_desconto':
            // CALCULAR O VALOR DA BASE DE CALCULO
            this.demEdiSerDocConCalcularValorBaseCalculo()

            // CHAMA A FUNÇÃO PARA CALCULAR O TOTAL
            this.demEdiSerDocConCalcularValorDoISS()

            // CHAMA A FUNÇÃO PARA CALCULAR O VALOR LIQUIDO
            this.demEdiSerDocConCalcularValorLiquido()
            break

          case 's_doc_iss_a':
            // CHAMA A FUNÇÃO PARA CALCULAR O TOTAL
            this.demEdiSerDocConCalcularValorDoISS()

            // CHAMA A FUNÇÃO PARA CALCULAR O VALOR LIQUIDO
            this.demEdiSerDocConCalcularValorLiquido()
            break

          case 's_doc_pis_a':
          case 's_doc_cofins_a':
          case 's_doc_csll_a':
          case 's_doc_irrf_a':
          case 's_doc_inss_a':
            // PEGA AS VARIAVEIS
            var porcentagem = indexF[1]
            var recebe = indexF[1].replace('_a', '_v')

            // CALCULA O VALOR DO IMPOSTO
            this.demEdiSerDocConCalcularValorRetencaoImposto(porcentagem, recebe)

            // CHAMA A FUNÇÃO PARA CALCULAR O TOTAL DA RETENÇÃO
            this.demEdiSerDocConCalcularValorTotalRetencao()
            break

          case 's_doc_r_outros_v':
            this.demEdiSerDocConCalcularValorTotalRetencao()
            break

          case 'retencoes':
            this.demEdiSerDocConCalcularValorLiquido()
            break
        }
      },
      demEdiSerDocConCalcularValorDoISS: function () {
        // CALCULA O VALOR DO ISS
        var valor = ((Number(this.campos.s_doc_bc.value) * Number(this.campos.s_doc_iss_a.value)) / 100).toFixed(0)

        // SETA O VALOR CALCULADO
        this.demEdiSerDocConOnChangeValue(valor, this.campos.s_doc_iss_v.id)
      },
      demEdiSerDocConCalcularValorBaseCalculo: function () {
        // CALCULA O VALOR DA BASE DE CALCULO
        var valor = (this.campos.s_doc_vTServico.value - this.campos.s_doc_desconto.value)

        // VERIFICA SE TEM O CAMPO DE DEDUÇÃO
        if ([ '', null, undefined ].indexOf(this.campos.s_doc_deducao_bc) === -1 && [ '', null, undefined, '0', '0,0', '0,00', 0 ].indexOf(this.campos.s_doc_deducao_bc.value) === -1) {
          // PEGA O VALOR DA DEDUÇÃO
          var deducao = this.campos.s_doc_deducao_bc.value

          // DIMINUI O VALOR DA DC
          valor -= Number(deducao)
        }

        // CHAMA A FUNÇÃO PARA ATUALIZAR O VALOR
        this.demEdiSerDocConOnChangeValue(valor, this.campos.s_doc_bc.id)
      },
      demEdiSerDocConCalcularValorLiquido: function () {
        // INICIA A VARIAVEL DO VALOR
        // var valor = this.campos.s_doc_bc.value
        var valor = this.campos.s_doc_vTServico.value - this.campos.s_doc_desconto.value

        // VERIFICA SE DEVE DESCONTAR O ISS
        if (this.campos.s_doc_iss_flag_r.value === true) {
          valor -= this.campos.s_doc_iss_v.value
        }

        // DIMINUI AS RETENÇÕES FEDERAIS
        if ([ '', null, undefined ].indexOf(this.campos.retencoes) === -1 && [ '', null, undefined ].indexOf(this.campos.retencoes.value) === -1) {
          valor -= this.campos.retencoes.value
        }

        // CHAMA A FUNÇÃO PARA ATUALIZAR O VALOR
        this.demEdiSerDocConOnChangeValue(valor, this.campos.s_doc_vTLiquido.id)
      },
      demEdiSerDocConCalcularValorTotalRetencao: function (onchange = true) {
        // INICIA A VARIAVEL DO VALOR
        var valor = 0

        // SOMA O VALOR DO IMPOSTO RETIDO
        valor += Number(this.campos.s_doc_pis_v.value)

        // SOMA O VALOR DO IMPOSTO RETIDO
        valor += Number(this.campos.s_doc_cofins_v.value)

        // SOMA O VALOR DO IMPOSTO RETIDO
        valor += Number(this.campos.s_doc_csll_v.value)

        // SOMA O VALOR DO IMPOSTO RETIDO
        valor += Number(this.campos.s_doc_irrf_v.value)

        // SOMA O VALOR DO IMPOSTO RETIDO
        valor += Number(this.campos.s_doc_inss_v.value)

        // SOMA O VALOR DO IMPOSTO RETIDO
        valor += Number(this.campos.s_doc_r_outros_v.value)

        // CHAMA A FUNÇÃO PARA ATUALIZAR O VALOR
        if (onchange === true) {
          this.demEdiSerDocConOnChangeValue(valor, this.campos.retencoes.id)
        } else {
          this.campos.retencoes.value = valor
        }
      },
      demEdiSerDocConCalcularValorRetencaoImposto: function (chaveP, chaveR) {
        // PEGA O VALOR DO CAMPO
        var aliquota = this.campos[chaveP].value

        // REMOVE A FORMATAÇÃO 
        if (isNaN(aliquota) !== false) {
          // REMOVE OS PONTOS DA STRING
          while (aliquota.indexOf('.') !== -1) {
            aliquota = aliquota.replace('.', '')
          }
          // REMOVE A VIRGULA DA STRING
          while (aliquota.indexOf(',') !== -1) {
            aliquota = aliquota.replace(',', '.')
          }
        }

        // INICIA A VARIAVEL DO VALOR
        var valor = ((Number(this.campos.s_doc_bc.value) * Number(aliquota)) / 100).toFixed(0)

        // CHAMA A FUNÇÃO PARA ATUALIZAR O VALOR
        this.demEdiSerDocConOnChangeValue(valor, this.campos[chaveR].id)
      },
      demEdiSerDocConSetarValorCampo: function (chave) {
        // INICIA A VARIAVEL DE VALOR
        var value = ''
        var valueRef = ''
        var options = []

        // VERIFICA O VALOR QUE DEVE SELECIONAR
        switch (chave) {
          case 's_doc_nat_ope':
            value = this.cpntSDocNatOpe
            break

          case 's_doc_ramo_id':
            value = this.cpntSDocRamoAtiv
            break

          case 's_doc_ati_id':
            value = this.cpntSDocAtividade
            break

          case 's_doc_cod_tri':
            value = this.cpntSDocCodTrib
            break

          case 's_doc_mun_pre_ser':
            value = this.cpntSDocMunicipioPrestacao
            break

          case 's_doc_descricao':
            value = this.cpntSDocDescricao
            break

          case 's_doc_vTServico':
            value = this.cpntSDocTotalServico
            break

          case 's_doc_deducao_bc':
            value = this.cpntSDocDeducaoBC
            break

          case 's_doc_desconto':
            value = this.cpntSDocDesconto
            break

          case 's_doc_bc':
            value = this.cpntSDocBaseCalculo
            break

          case 's_doc_iss_a':
            value = this.cpntSDocIssAliquota
            break

          case 's_doc_iss_v':
            value = ((Number(this.cpntSDocBaseCalculo) * Number(this.cpntSDocIssAliquota)) / 100).toFixed(0)
            break

          case 's_doc_iss_flag_r':
            value = this.cpntSDocFlagReterIss === '1'
            break

          case 's_doc_vTLiquido':
            value = this.cpntSDocValorLiquido
            break

          case 's_doc_pis_a':
            value = this.cpntSDocPisAliquota
            break

          case 's_doc_pis_v':
            value = this.cpntSDocPisValor
            break

          case 's_doc_cofins_a':
            value = this.cpntSDocCofinsAliquota
            break

          case 's_doc_cofins_v':
            value = this.cpntSDocCofinsValor
            break

          case 's_doc_csll_a':
            value = this.cpntSDocCsllAliquota
            break

          case 's_doc_csll_v':
            value = this.cpntSDocCsllValor
            break

          case 's_doc_irrf_a':
            value = this.cpntSDocIrrfAliquota
            break

          case 's_doc_irrf_v':
            value = this.cpntSDocIrrfValor
            break

          case 's_doc_inss_a':
            value = this.cpntSDocInssAliquota
            break

          case 's_doc_inss_v':
            value = this.cpntSDocInssValor
            break

          case 's_doc_r_outros_v':
            value = this.cpntSDocOutrasRetencoesValor
            break

          case 'retencoes':
            if (this.iniciando === false) {
              this.demEdiSerDocConCalcularValorTotalRetencao(false)
            }
            break

          case 's_doc_ret':
            value = this.cpntSDocManualRetencao
            break

          case 's_doc_des':
            value = this.cpntSDocManualDesconto
            break

          case 's_doc_emi':
            value = this.cpntSDocManualDataEmissao
            break
          
          case 's_doc_cv':
            value = this.cpntSDocManualCodVerificacao
            break

          case 's_doc_n':
            value = this.cpntSDocManualNumero
            break

          case 's_doc_s':
            value = this.cpntSDocManualSerie
            break
        }

        // VERIFICA SE TEM ALGUM VALOR VALIDO PARA O CAMPO
        if ([ '', null, undefined, NaN ].indexOf(value) !== -1 || (typeof value === 'string' && Object.is(NaN, value) === true)) {
          value = ''
        }

        // QUEBRA A LIGAÇÃO DO VUE
        value = JSON.parse(JSON.stringify(value))

        // VERIFICA SE TEM OPTION E O VALOR SELECIONADO É UM STRING
        if (options.length >= 1 && typeof value === 'string') {
          // PEGA O VALOR DO CAMPO
          var valor = options.filter((option) => { return option[this.campos[chave].keyValue] === value })

          // SETA O VALOR ENCONTRADO
          value = valor.length === 1 ? valor[0] : value
        }

        // VERIFICA SE É UM NUMERO, SE FOR CONVERTE PARA STRING
        if (this.campos[chave].mask === 'VALOR_DECIMAL_CAMPO') {
          // VERIFICA SE É UM NUMERO OU STRING
          if (isNaN(value) === false) {
            // CONVERTE O VALOR EM STRING
            value = Number(value).toString()

            // ALTERA O PONTO PARA VIRGULA
            while (value.indexOf('.') !== -1) {
              value = value.replace('.', ',')
            }
          }

          // CONVERTE O CAMPO EM NUMERO
          value = value.toString()
        }

        // SETA O VALOR ATUALIZADO DO CAMPO
        this.$set(this.campos[chave], 'value', value)
        this.$set(this.campos[chave], 'valueIni', value)
        this.$set(this.campos[chave], 'options', options)
        this.$set(this.campos[chave], 'valueRef', valueRef)

        // CHAMA A FUNÇÃO PARA CALCULAR O TOTAL
        if (this.iniciando === false && chave === 's_doc_vTLiquido') {
          this.demEdiSerDocConCalcularValorDoISS()
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiSerDocConOnBuscarNaturezaOperacao: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 }, order: { id: 'asc' } }

          // SETA O NOME DOS CAMPOS
          queryGet.field = { id: null, nome: null }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/ser-nat-operacao/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiSerDocConOnBuscarNaturezaOperacao(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.s_doc_nat_ope.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.$set(this.campos.s_doc_nat_ope, 'options', registros)

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiSerDocConOnBuscarRamoAtividade: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // INICIA O QUERY GET
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { cnae: null, nome: null } }
  
          // SETA O WHERE
          queryGet.where = { f: 'cnae', o: 'in', v: this.$store.state.licenca.cnae.aRamIds.join() }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/cnae/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiSerDocConOnBuscarRamoAtividade(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.s_doc_ramo_id.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.$set(this.campos.s_doc_ramo_id, 'options', registros)

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiSerDocConOnBuscarAtividade: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // INICIA O QUERY GET
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, nome: null } }
  
          // SETA O WHERE
          queryGet.where = { f: 'id', o: 'in', v: this.$store.state.licenca.atividade.aAtiIds.join() }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/ser-atividade/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiSerDocConOnBuscarAtividade(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.s_doc_ati_id.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.$set(this.campos.s_doc_ati_id, 'options', registros)

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
    },
    watch: {
      cpntSDocNatOpe: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_nat_ope')
      },
      cpntSDocRamoAtiv: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_ramo_id')
      },
      cpntSDocAtividade: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_ati_id')
      },
      cpntSDocCodTrib: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_cod_tri')
      },
      cpntSDocMunicipioPrestacao: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_mun_pre_ser')
      },
      cpntSDocDescricao: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_descricao')
      },
      cpntSDocTotalServico: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_vTServico')
      },
      cpntSDocDeducaoBC: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_deducao_bc')
      },
      cpntSDocDesconto: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_desconto')
      },
      cpntSDocBaseCalculo: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_bc')
      },
      cpntSDocIssAliquota: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_iss_a')
      },
      cpntSDocFlagReterIss: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_iss_flag_r')
      },
      cpntSDocValorLiquido: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_vTLiquido')
      },
      cpntSDocPisAliquota: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_pis_a')
      },
      cpntSDocPisValor: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_pis_v')
      },
      cpntSDocCofinsAliquota: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_cofins_a')
      },
      cpntSDocCofinsValor: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_cofins_v')
      },
      cpntSDocCsllAliquota: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_csll_a')
      },
      cpntSDocCsllValor: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_csll_v')
      },
      cpntSDocIrrfAliquota: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_irrf_a')
      },
      cpntSDocIrrfValor: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_irrf_v')
      },
      cpntSDocInssAliquota: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_inss_a')
      },
      cpntSDocInssValor: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_inss_v')
      },
      cpntSDocOutrasRetencoesValor: function () {
        this.demEdiSerDocConSetarValorCampo('s_doc_r_outros_v')
      }
    }
  }
</script>
